/**
 * @description  Bot routing preferences
 */

export default Object.freeze({
  BOT_FIRST: 'BOT_FIRST',
  IF_NO_AGENT: 'ONLY_IF_NO_AVAILABLE_AGENT',
})
